import ECO from '../../assets/projects_images/ECO.png'
import PIZZA from '../../assets/projects_images/PIZZA.png'
import SASS from '../../assets/projects_images/SASS.png'
import singlepage from '../../assets/projects_images/singlepage.png'
import PYTHON from '../../assets/projects_images/PYTHON.png'
import MACHINE from '../../assets/projects_images/MACHINE.png'


const data_projects = [
    
    {
        name: 'eCommerce Furniture Shop',
        image: ECO,
       // deployed_url: 'https://covid-19-tracker-by-sumit.web.app/',
        github_url: 'https://github.com/Kuldeepdawar/eCommece-Furniture-shop',
        category: ['react.js']
    },


    {
        name: 'Pizza Restaurant',
        image: PIZZA,
       // deployed_url: 'https://dev-talks.herokuapp.com/',
        github_url: 'https://github.com/Kuldeepdawar/Pizza-website',
        category: ['react.js']
    },

    {
        name: 'React Sass App',
        image: SASS,
        //deployed_url: 'https://sumit-chat.netlify.app/',
        github_url: 'https://github.com/Kuldeepdawar/React-Sass-website-',
        category: ['react.js']
    },

    {
        name: 'Single Page App',
        image: singlepage,
        //deployed_url: 'http://sumaxtweetme.pythonanywhere.com/',
        github_url: 'https://github.com/kuldeepdawa/Singlepageapp',
        category: ['react']
    },

    
   
]

export default data_projects;